import useCompleteTaskModal from "./CompleteTask"

import { usePickDateModal } from "web/hooks/modals"

export default function useTaskActions({ task, showDealContext }) {
  const pickDateModal = usePickDateModal()

  const completeTaskModal = useCompleteTaskModal(showDealContext)

  async function setTaskDueDate(event) {
    event && event.stopPropagation()

    const dueDate = await pickDateModal({ title: "Task Due Date" })

    if (dueDate) {
      return task.update({ due_date: dueDate })
    }
  }

  async function removeTaskDueDate() {
    return task.update({ due_date: null })
  }

  async function completeTask() {
    return await completeTaskModal({ task })
  }

  async function uncompleteTask() {
    await task.update({ status: "in_progress" })
  }

  return {
    completeTask,
    uncompleteTask,
    setTaskDueDate,
    removeTaskDueDate,
  }
}
